import { createGlobalStyle } from 'styled-components';

const GlobalStyles = createGlobalStyle`
  @font-face {
    font-family: 'Gamwulchi Free Gothic';
    src: url('/font/gamwulchifreegothic/GamwulchiFreeGothic.woff2') format('woff2'),
         url('/font/gamwulchifreegothic/GamwulchiFreeGothic.woff') format('woff');
    font-weight: normal;
    font-style: normal;
    font-display: swap;
  }

  * {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
    caret-color: transparent; /* 커서 깜빡임 방지 */
  }

  body {
    font-family: 'Noto Sans KR', -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',
      'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',
      sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    line-height: 1.6;
    color: #3E2723;
    background: #FAF8F3;
  }

  /* 한국어 줄바꿈 최적화 */
  body, p, div, span, li, td, th, h1, h2, h3, h4, h5, h6 {
    word-break: keep-all; /* 한국어 단어가 중간에 끊기지 않음 */
    overflow-wrap: break-word; /* 너무 긴 단어만 줄바꿈 */
    word-wrap: break-word; /* IE/Edge 호환성 */
  }

  /* 텍스트 콘텐츠 요소에만 \n을 줄바꿈으로 표시 */
  p, span, h1, h2, h3, h4, h5, h6, li, td, th {
    white-space: pre-line;
  }

  a {
    text-decoration: none;
    color: inherit;
  }

  ul {
    list-style: none;
  }

  button {
    cursor: pointer;
    border: none;
    outline: none;
    background: none;
  }

  img {
    max-width: 100%;
    height: auto;
  }

  h1, h2, h3, h4, h5, h6 {
    line-height: 1.2;
  }

  /* 입력 필드는 텍스트 선택 및 커서 표시 가능하게 */
  input, textarea {
    user-select: text;
    -webkit-user-select: text;
    -moz-user-select: text;
    -ms-user-select: text;
    caret-color: auto; /* 입력 필드에서는 커서 표시 */
  }
`;

export default GlobalStyles;